<template>
  <div class="question-container">
    <div v-if="mode == 0">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question.isSkippable">Optional</span>
        </div>
        <div class="col-md-7">
          <template v-if="answer && answer.answerText">
            <div>{{ answer[JsonFieldToDisplay()] }}</div>
          </template>
        </div>
        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else-if="question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- EDIT MODE -->
    <div v-if="mode == 1">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="question.isSkippable">Optional</span>
          <span class="skipped-question-box ml-15 d-inline-box pt-2" v-if="isQuestionSkipped()">Skipped </span>
        </div>
        <div class="col-md-7" :class="isQuestionSkipped() ? 'disable-question' : ''">
          <slot>
            <input class="form-control" type="number" :min="question.minValue" :max="question.maxValue" :disabled="answer && answer.isDisabled" v-model="updatedAns" @change="answerUpdated" :name="question.id" :class="{ 'is-danger': hasFieldError }" data-vv-as="Number" />
          </slot>
          <span class="text-danger" v-if="hasFieldError">
            <p>{{ fieldErrorText }}</p>
          </span>
          <span v-if="hasFieldWarning" class="text-warning pl-5 fw-bold pt-10">
            {{ fieldWarningText }}
          </span>
        </div>

        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else-if="question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- RESPONSE MODE -->
    <div v-else-if="mode == 2">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <div class="row">
            <div class="col-md-12 d-flex p-0 answers">
              <span class="changed" v-if="answer && answer.edit_status == 1"></span>
              <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
              <template v-if="activityType == 'activity'">
                <span class="question-text" v-html="question.formattedBody"></span>
              </template>
              <template v-else>
                <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
                <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
              </template>
              <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question.isSkippable">Optional</span>
            </div>
            <!-- CURRENT ANSWER -->
            <template v-if="answer && answer.answer_text">
              <div class="col-md-12 d-flex pl-30">
                <span class="text-align">{{ selectedLanguageCulture == "EN" ? answer.answer_text : answer.display_answer_text }}</span>
              </div>
              <div class="row">
                <div class="d-inline-block ml-25 pt-10" v-if="showScore && activityType == 'activity' && answer.score != null">
                  <label>Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                    {{ answer.score }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="question.isSkippable">
              <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                <label class="fs-12">Score</label>
                <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                  {{ question.skipScore || 0 }}
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="col-md-7 previous-answer" v-if="answer && answer.edit_status == 1">
          <div>
            <span class="previous-value-mark"></span>
            <div class="previous-value ml-3">PREVIOUS RESPONSE</div>

            <template v-if="answer && answer.privius_answer_text">
              <div>
                <span class="text-align">{{ selectedLanguageCulture == "EN" ? answer.privius_answer_text : answer.privius_display_answer_text }}</span>
              </div>
              <div class="row">
                <div class="d-inline-block ml-0 pt-10" v-if="showScore && answer.privius_score != null">
                  <label>Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                    {{ answer.privius_score }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="question.isSkippable">
              <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                <label class="fs-12">Score</label>
                <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                  {{ question.skipScore || 0 }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import activityCommonMixin from "./activity-common-mixin";
export default {
  name: "NumberResponse",
  mixins: [activityCommonMixin],
  data() {
    return {
      updatedAns: "",
      hasFieldError: null,
      fieldErrorText: "",
      hasFieldWarning: false,
      fieldWarningText: ""
    };
  },
  watch: {
    mode: {
      handler(value) {
        if (value == 0) {
          this.updatedAns = this.answer.answerText;
        }
      }
    },
    updatedAns() {
      if (this.answer) {
        this.answer.answerText = this.updatedAns;
        this.answer.score = this.question.score;
        this.answer.computedScore = this.answer.score;
        this.answer.score = this.updatedAns;
      }
    },
    hasFieldError(val) {
      this.question.hasFieldError = val;
    },
    fieldErrorText(val) {
      this.question.fieldErrorText = val;
    }
  },
  mounted() {
    if (this.answer) {
      this.updatedAns = this.answer.answerText;
    }
  },
  props: {
    mode: Number,
    answer: Object,
    question: Object,
    usage: Object,
    surveyData: Object,
    stepIndex: Number,
    selectedLanguageCulture: String,
    activityType: String
  },

  methods: {
    answerUpdated() {
      this.checkForFieldErrors();
      this.$emit(`answerChanged`, {
        questionId: this.question.id,
        newAns: this.updatedAns
      });
    },
    checkForFieldErrors() {
      let { minValue, maxValue, hasMinMax, hasSoftMinMax, allowDecimals, allowNegative, softminValue, softmaxValue, isSkippable, decimalValue, dataEditChecks } = this.question;

      this.resetAllErrors();
      this.question.dataChecks = [];
      if (dataEditChecks) {
        let softDataCheck = false;
        for (let k = 0; k < dataEditChecks.length; k++) {
          if (dataEditChecks[k].check == "SOFT") {
            if (dataEditChecks[k].type == "DATA_TYPE" && dataEditChecks[k].value == "Numeric" && !Number.isInteger(Number(this.updatedAns))) {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              this.fieldWarningText = `Your response is not in the expected format: Numeric. Please review your response.`;
              isSkippable = true;
              this.question.dataChecks.push({
                dataCheckId: dataEditChecks[k].id,
                dataCheckType: dataEditChecks[k].type,
                message: this.fieldWarningText
              });
              softDataCheck = true;
            }
            if (dataEditChecks[k].type == "DATA_FORMAT") {
              if (!Number.isInteger(Number(dataEditChecks[k].value))) {
                allowDecimals = true;
                let validateDecimal = this.regulateDecimal(this.updatedAns, dataEditChecks[k].value);
                if (!validateDecimal) {
                  let message = this.convertMessage(dataEditChecks[k].value);
                  this.hasFieldError = false;
                  this.hasFieldWarning = true;
                  this.fieldErrorText = "";
                  this.fieldWarningText = `Your response is not in the expected format: ${message}. Please review your response.`;
                  this.question.dataChecks.push({
                    dataCheckId: dataEditChecks[k].id,
                    dataCheckType: dataEditChecks[k].type,
                    message: this.fieldWarningText
                  });
                  softDataCheck = true;
                }
              } else if (Number.isInteger(Number(dataEditChecks[k].value))) {
                let validateDecimal = this.regulateDecimal(this.updatedAns, dataEditChecks[k].value);
                if (!validateDecimal) {
                  let message = this.convertMessage(dataEditChecks[k].value);
                  this.hasFieldError = false;
                  this.hasFieldWarning = true;
                  this.fieldErrorText = "";
                  this.fieldWarningText = `Your response is not in the expected format: ${message}. Please review your response.`;
                  this.question.dataChecks.push({
                    dataCheckId: dataEditChecks[k].id,
                    dataCheckType: dataEditChecks[k].type,
                    message: this.fieldWarningText
                  });
                  softDataCheck = true;
                }
              }
            }
          } else {
            if (dataEditChecks[k].type == "DATA_TYPE" && dataEditChecks[k].value == "Numeric" && !Number.isInteger(Number(this.updatedAns))) {
              this.hasFieldError = true;
              this.fieldErrorText = `Please enter a response with format: Numeric.`;
              isSkippable = false;
            }
            if (dataEditChecks[k].type == "DATA_FORMAT") {
              if (!Number.isInteger(Number(dataEditChecks[k].value))) {
                allowDecimals = true;
                let validateDecimal = this.regulateDecimal(this.updatedAns, dataEditChecks[k].value);
                if (!validateDecimal) {
                  let message = this.convertMessage(dataEditChecks[k].value);
                  this.hasFieldError = true;
                  this.fieldErrorText = `Please enter a response using format: ${message}.`;
                  isSkippable = false;
                }
              } else if (Number.isInteger(Number(dataEditChecks[k].value))) {
                let validateDecimal = this.regulateDecimal(this.updatedAns, dataEditChecks[k].value);
                if (!validateDecimal) {
                  let message = this.convertMessage(dataEditChecks[k].value);
                  this.hasFieldError = true;
                  this.fieldErrorText = `Please enter a response using format: ${message}.`;
                  isSkippable = false;
                }
              }
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }

      if (!isSkippable && (this.updatedAns == "" || this.updatedAns == undefined)) {
        this.hasFieldError = true;
        this.fieldErrorText = `This field is required.`;
        return;
      }
      if (!this.hasFieldError) {
        if (this.validateIsValidNumber(this.updatedAns)) {
          return;
        }

        const answer = Number(this.updatedAns);

        if (hasMinMax) {
          if (this.validateMinMaxErrors(answer, minValue, maxValue, hasSoftMinMax, softminValue, softmaxValue)) {
            return;
          }
        }

        if (this.validateAllowDecimals(answer, allowDecimals, decimalValue)) {
          return;
        }
        if (this.validateAllowNegativeValues(answer, allowNegative)) {
          return;
        }

        this.hasFieldError = false;
      }
    },
    validateMinMaxErrors(answer, minValue, maxValue, hasSoftMinMax, softminValue, softmaxValue) {
      if (answer < minValue) {
        this.hasFieldError = true;
        this.fieldErrorText = `Answer should have a min of ${minValue}`;
        if (hasSoftMinMax) {
          if (answer > softminValue) {
            this.hasFieldError = false;
            this.hasFieldWarning = true;
            this.fieldErrorText = "";
            this.fieldWarningText = `This value is less than min ${minValue} but greater than soft min ${softminValue}`;
            return false;
          }
        }
        return true;
      }

      if (answer > maxValue) {
        this.hasFieldError = true;
        this.fieldErrorText = `Answer should have a max of ${maxValue}`;
        if (answer < softmaxValue) {
          this.hasFieldError = false;
          this.hasFieldWarning = true;
          this.fieldErrorText = "";
          this.fieldWarningText = `This value is greater than max ${maxValue} but less than soft max ${softmaxValue}`;
        }
        return true;
      }

      return false;
    },
    validateAllowDecimals(answer, allowDecimals, decimalValue) {
      if (allowDecimals) {
        const charCode = answer.toString();
        if (charCode.includes(".")) {
          const numb = charCode.split(".")[1];
          if (numb != null && numb.length > decimalValue) {
            this.hasFieldError = true;
            this.fieldErrorText = `Up to ${decimalValue} decimals are allowed.`;
            return true;
          }
        }
      }
      if (allowDecimals) {
        return false;
      }
      if (!allowDecimals && !Number.isInteger(answer)) {
        this.hasFieldError = true;
        this.fieldErrorText = `Decimals not allowed`;
        return true;
      }
    },
    validateAllowNegativeValues(answer, allowNegative) {
      if (allowNegative) {
        return false;
      }
      if (answer < 0) {
        this.hasFieldError = true;
        this.fieldErrorText = `Negative value not allowed`;
        return true;
      }
    },
    validateIsValidNumber(answer) {
      if (isNaN(Number(answer))) {
        this.hasFieldError = true;
        this.fieldErrorText = `Answer should be a valid number`;
        return true;
      }
      return false;
    },

    resetAllErrors() {
      this.hasFieldError = false;
      this.fieldErrorText = "";
      this.hasFieldWarning = false;
      this.fieldWarningText = "";
    },
    regulateDecimal(answer, decimal) {
      if (decimal.includes(".") && answer.includes(".")) {
        const decimalValue = decimal.split(".");
        const answerValue = answer.split(".");
        if (answerValue[0].replace(/\s/g, "").length > decimalValue[0] || !answerValue[0].trim().length) {
          return false;
        }
        if (answerValue[1].replace(/\s/g, "").length > decimalValue[1] || !answerValue[1].trim().length) {
          return false;
        }
      } else if (decimal.includes(".")) {
        return false;
      } else if (answer.length > decimal) {
        return false;
      }

      return true;
    },
    convertMessage(number) {
      let stringMessage = "";

      if (number.includes(".")) {
        const numberValue = number.split(".");
        for (let i = 1; i <= numberValue[0]; i++) {
          stringMessage += "x";
        }
        stringMessage += ".";
        for (let i = 1; i <= numberValue[1]; i++) {
          stringMessage += "y";
        }
      } else {
        for (let i = 1; i <= number; i++) {
          stringMessage += "x";
        }
      }

      return stringMessage;
    },
    isQuestionSkipped() {
      return this.answer.isSkipped;
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.changed {
  position: absolute;
  left: -29px;
  top: 0;
  width: 18px;
  height: 51px;
  border-radius: 1px;
  background-color: #f5a623;
}
.question-text {
  display: inline;
}

.previous-value-mark {
  width: 9px;
  height: 51px;
  background-color: #f5a623;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.previous-value {
  /* font-family: Roboto; */
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #f5a623;
  margin-bottom: 9px;
  margin-top: 3px;
}

.answers {
  font-weight: 600;
  color: #000000;
}
</style>
